import { useEffect } from "react";
import { useSearchParams, Navigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuthUser } from "../lib/auth";
import { apiUrl } from "../lib/api";
import { Wordmark } from "../components/Wordmark";

const ERROR_MESSAGES: Record<string, string> = {
  unauthorized: "Diese E-Mail ist nicht freigeschaltet.",
  email_unverified: "Google-E-Mail nicht verifiziert.",
  no_code: "Anmeldung abgebrochen.",
  token_exchange_failed: "Token-Tausch mit Google fehlgeschlagen.",
  userinfo_failed: "Profil-Daten konnten nicht geladen werden.",
  access_denied: "Anmeldung von Google verweigert.",
};

export function LoginPage() {
  const { data, isLoading } = useAuthUser();
  const [params, setParams] = useSearchParams();
  const error = params.get("error");

  useEffect(() => {
    if (error) {
      toast.error(ERROR_MESSAGES[error] || `Anmeldung fehlgeschlagen: ${error}`);
      setParams({}, { replace: true });
    }
  }, [error, setParams]);

  if (isLoading) return null;
  if (data) return <Navigate to="/" replace />;

  return (
    <div className="flex h-full items-center justify-center px-6">
      <div className="w-full max-w-sm space-y-10 text-center">
        <div className="space-y-3">
          <div className="flex justify-center">
            <Wordmark />
          </div>
          <h1 className="text-2xl font-extrabold lowercase tracking-tight text-text-primary">
            admin
          </h1>
          <p className="text-sm text-text-secondary">
            Anmeldung nur für freigeschaltete Konten.
          </p>
        </div>

        <a
          href={apiUrl("/auth/google")}
          className="inline-flex w-full items-center justify-center gap-2 rounded-md bg-accent px-4 py-2.5 text-sm font-medium text-text-on-accent transition-colors hover:bg-accent-hover"
        >
          Mit Google anmelden
        </a>
      </div>
    </div>
  );
}
